import React from 'react';
import { Drawer, Select, Button } from 'antd';
import ButtonList from '../../../views/ButtonList';
// eslint-disable-next-line import/extensions
import S from '../styles';
import WrappedCatForm from './CatForm';

class TitleBar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      drawerVisible: false,
    };

    this.setDrawerVisible = this.setDrawerVisible.bind(this);
    this.onClose = this.onClose.bind(this);
    this.loadAllJobs = this.props.loadAllJobs2;
  }

  setDrawerVisible(drawerVisible) {
    this.setState({ drawerVisible });
  }

  onClose() {
    this.setDrawerVisible(false);
  }

  render() {
    return (
      <React.Fragment>
        <h1 style={S.titleText}>Category Jobs</h1>
        <ButtonList compact line={false} style={({ flex: 1 })}>
          <Button type="primary" icon="plus" onClick={() => this.setDrawerVisible(true)}>New</Button>
        </ButtonList>

        <Drawer
          title="Categorize Media"
          placement="right"
          maskClosable
          width={400}
          closable
          onClose={this.onClose}
          visible={this.state.drawerVisible}
          destroyOnClose={true}
        >
          <WrappedCatForm setDrawerVisible={this.setDrawerVisible} loadAllJobs3={this.loadAllJobs} categories={this.props.categories} bearerToken={this.props.bearerToken} />
        </Drawer>
      </React.Fragment>
    );
  }
}

export default TitleBar;
